module.exports = __webpack_public_path__ + "img/155.6d8ba665.jpg";